<template>
  <div>
    <Header />
    <Loading v-show="loading"/>
    <div id="app" class="container" v-show="!loading">
      <router-view/>
    </div>
    <Footer v-show="!loading"/> 
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Loading from './components/Loading.vue'

export default {
  name: 'App',
  data() {
    return {
      loading: true
    }
  },
  components: {
    Header,
    Footer,
    Loading
  },
  methods: {
    scrollTop: function(){
      window.scrollTo({
        top: 0
      });
    }
  },
  mounted: function() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  updated: function() {
    this.$nextTick(function () {
      this.scrollTop();
    })

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue